"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferType = void 0;
// The types of transfers utilized by the system
var TransferType;
(function (TransferType) {
    TransferType["CONNECT"] = "connect";
    TransferType["GATEWAY"] = "gateway";
    TransferType["PLUGINLESS"] = "pluginless";
})(TransferType = exports.TransferType || (exports.TransferType = {}));
